import { SelectOption } from "@models/ui-models/select-options";
import { DocumentationType } from "@models/documents/document-enums";

export function getDocumentationTypeOptions(...excludedOptions: DocumentationType[]): SelectOption<DocumentationType>[] {
  const defaultDocumentationTypeOptions = [
    { label: 'Minutes', value: DocumentationType.Minutes },
    { label: 'Resolution', value: DocumentationType.Resolution },
    { label: 'ASIC Form only', value: DocumentationType.FormOnly }
  ];

  return defaultDocumentationTypeOptions.filter((option) => !excludedOptions.includes(option.value));
}
